import type { FC } from 'react'
import styled from '@emotion/styled'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import DemoForm from '@segment/templates/Forms/DemoForm'

const copy = {
  overline: `WhatsApp`,
  heading: `Deliver personalized, real-time experiences on a global scale`,
  description: `With an audience of over 2 billion users, WhatsApp is the perfect channel for marketers to connect and engage with their global audiences. By leveraging WhatsApp, marketers can reach new markets, create meaningful relationships, and grow their brand presence natively in Twilio Engage.`,
}

const Hero: FC = () => {
  return (
    <Wrapper>
      <StyledHeroBase variant="centered">
        <HeroRecipe.Copy>
          <CopyText.Overline tag="h5">{copy.overline}</CopyText.Overline>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pExtraLarge" tag="p">
            {copy.description}
          </CopyText.Description>
          <HeroRecipe.Form>
            <DemoForm
              isProgressive={true}
              customFormIdentifier="site-whatsapp-demo"
              successMessageAppearance="twilioLight"
            />
          </HeroRecipe.Form>
        </HeroRecipe.Copy>
      </StyledHeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

const StyledHeroBase = styled(HeroBase)`
  ${HeroRecipe.Wrapper} {
    text-align: start;

    ${({ theme }) => theme.breakpoints.up(`md`)} {
      text-align: center;
    }
  }
`

export default Hero
